"use client";

import { useTranslations } from "../../../../../../@i18n/rr/src";
import type { UseCountdownProps } from "../../../hooks/useCountdown";
import { useCountdown } from "../../../hooks/useCountdown";

export const Countdown = (props: UseCountdownProps) => {
  const countdown = useCountdown(props);
  const t = useTranslations();

  return t("challenge_tile_starts_in", {
    0: countdown,
  });
};
